<template>
  <div class="directory-detail clearfix">
    <TMSHeader
      :title="title"
      :fullScreen="true"
    >
      <div
        slot="status"
        :class="pointerClass"
        @click="openLifecycleFun"
      >
        <TheDirStatusHeader />
      </div>
      <template slot="before-buttons">
        <button
          v-if="canEdit"
          type="button"
          class="btn btn--darkblue"
          @click="edit()"
        >{{ $t('action.edit') }}</button>
        <button
          v-if="canEditPublished"
          type="button"
          class="btn btn--darkblue"
          @click="action(ACTION.editPublished)"
        >{{ $t('action.edit') }}</button>
      </template>
    </TMSHeader>
    <Modal
      :modalId="`dir-alert-${id}`"
      ref="alertActionMsg"
    >
      <div
        class="font-bold"
        slot="content"
      >
        <div v-html="alertMsg" />
      </div>
      <div slot="btns">
        <button
          type="button"
          class="btn btn--orange close-reveal-modal"
          @click="doIt()"
        >{{ $t('action.yesContinue') }}</button>
      </div>
    </Modal>
    <Lifecycle
      v-if="isEngineer"
      ref="directoryLifecycle"
      :modalId="'directory-modules-lifecycle-modal'"
      :type="'directory'"
      :commentAttr="lifecycleCommentAttrs.comments"
      :histories="histories"
      :allowPreformattedComments="true"
      :emptyHistoryHint="emptyHistoryHint"
    />
    <div class="directory-detail__info clearfix">
      <div class="effective--date-reject-history">
        <div :class="[isFloorDR ? 'floor-effective-remove-date': 'effective-remove-date']">
          <div
            class="effective-date"
            v-if="hasRemoveDate"
          >
            <label class="emphasis">{{ $t('directory.removeDate') }}</label>
            <DatePicker
              id="directory-effective-date"
              :required="true"
              :calendarButton="true"
              calendarButtonIcon="fa fa-calendar"
              :disabledPicker="true"
              :value="currentDirectory.removeDate | formatDate"
            />
          </div>
          <div class="effective-date">
            <label class="emphasis">{{ $t('directory.effectiveDate') }}</label>
            <DatePicker
              id="directory-effective-date"
              :required="true"
              :calendarButton="true"
              calendarButtonIcon="fa fa-calendar"
              :disabledPicker="true"
              :value="currentDirectory.effectiveDate | formatDate"
            />
          </div>
          <div
            v-if="isFloorDR"
            class="floor"
          >
            <label class="emphasis">{{ $t('directory.label.floor') }}</label>
            <HKLSelect
              :options="[]"
              placeholder=""
              :value="currentDirectory.floor"
              :required="true"
              :disabled="true"
            />
          </div>
        </div>
        <div
          class="guideline"
          :class="['guideline', isFloorDR ? 'floor-guideline': '']"
        >
          <div class="emphasis guideline-title">{{ $t(`termsAndConditions.${regionName}.directoryGuideLine.title`) }}</div>
          <ol>
            <li
              v-for="(item, key) in $t(`termsAndConditions.${regionName}.directoryGuideLine.content`)"
              :key="key"
            >{{ item }}</li>
          </ol>
        </div>
      </div>
      <div
        class="reject-history"
        v-if="latestRejectedHistory"
      >
        <label class="emphasis">{{ $t('directory.label.commentsFromOn',[latestRejectedHistory.who, latestRejectedHistory.when]) }}</label>
        <div class="reject-history__item">
          <div class="reject-comment">
            <pre>{{ latestRejectedHistory.comment }}</pre>
          </div>
        </div>
      </div>
      <template>
        <div
          class="row"
          v-if="companies.length"
        >
          <div class="small-6 large-6 columns detail">
            <template v-for="(company, index) in companies">
              <Company
                :id="company.id"
                :index="index"
                :key="company.id"
                :company.sync="company"
                :type="currentDirectory.type"
              />
            </template>
          </div>
          <div class="small-6 large-6 preview">
            <img :src="directoryImg">
            <UploadDocs />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Company from './Company'
import DatePicker from '@/controls/DatePicker'
import Lifecycle from '@/modules/Lifecycle'
import HKLSelect from '@/controls/Select/HKLSelect'
import Modal from '@/controls/Modal'
import TMSHeader from '@/controls/TMSHeader'
import TheDirStatusHeader from './TheDirStatusHeader'
import directoryDetailMixin from './directoryDetailMixin'
import directoryEditBtnMixin from './directoryEditBtnMixin'
import UploadDocs from './UploadDocs'

import { lifecycleCommentAttrs } from '@/utils/consts'
import { mapGetters } from 'vuex'

export default {
  name: 'DirectoryDetail',
  components: {
    TheDirStatusHeader,
    Company,
    DatePicker,
    HKLSelect,
    TMSHeader,
    Lifecycle,
    Modal,
    UploadDocs,
  },
  mixins: [directoryDetailMixin, directoryEditBtnMixin],
  data () {
    return {
      lifecycleCommentAttrs,
      emptyHistoryHint: this.$t('hint.emptyDirectoryLifecycle'),
    }
  },

  computed: {
    ...mapGetters('regions', ['regionName']),
    id () {
      return this.$route.params.id
    },
    hasRemoveDate () {
      return this.currentDirectory && this.currentDirectory.removeDate
    },
    buttons () {
      let buttons = []
      return buttons
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/directories/detail';
</style>
